import React from 'react';
import TransferMethodDF from '../components/SimulatorsComponents/DefualtSimulators/TransferMethodDF';
import { getSubCategoryId } from '../utils/DictionaryManagementUtils';

//= ========================================================================

const Sim_G03_SplitPaymentTransferMethod = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs = null,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { recipient } = globJSON.configurations.services[subCategoryId];

  return (
    <TransferMethodDF
      globJSON={globJSON}
      selectedScreen={selectedScreen}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
      recipient={recipient}
    />
  );
};

export default Sim_G03_SplitPaymentTransferMethod;
